import type { ReactNode } from 'react'
import { TooltipProvider } from '@/ui/shadcn/tooltip'

export function AppProviders({ children }: { children: ReactNode }) {
  return <TooltipProvider delayDuration={350}>{children}</TooltipProvider>
}
